/* eslint-disable */
import React, { useMemo, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import "../styles/parent/ParentHome.css";

function BellIcon() {
  return (
    <svg viewBox="0 0 24 24" className="pp-home-mini-icon" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M15 17h5l-1.4-1.4a2 2 0 0 1-.6-1.4V11a6 6 0 1 0-12 0v3.2a2 2 0 0 1-.6 1.4L4 17h5" />
      <path d="M10 21a2 2 0 0 0 4 0" />
    </svg>
  );
}

function ChevronIcon() {
  return (
    <svg viewBox="0 0 24 24" className="pp-home-mini-icon pp-home-chevron" fill="none" stroke="currentColor" strokeWidth="2.4">
      <path d="M9 18l6-6-6-6" />
    </svg>
  );
}

function getUpdateCategory(item) {
  const raw = String(item.category || item.type || item.kind || "").toLowerCase();

  if (raw.includes("absence")) return "Absence";
  if (raw.includes("attendance")) return "Attendance";
  if (raw.includes("report")) return "Report";
  if (raw.includes("behaviour")) return "Behaviour";

  return "Update";
}

function getUpdateTone(item, read) {
  const category = getUpdateCategory(item).toLowerCase();

  if (read) {
    return { label: "Read", bg: "#ecfdf5", color: "#027a48" };
  }

  if (category === "absence") {
    return { label: "Absence", bg: "#eff6ff", color: "#175cd3" };
  }

  if (category === "attendance") {
    return { label: "Attendance", bg: "#fef0c7", color: "#b54708" };
  }

  if (category === "report") {
    return { label: "Report", bg: "#ede9fe", color: "#6d28d9" };
  }

  return { label: "New", bg: "#fef0c7", color: "#b54708" };
}

export default function ParentNotifications() {
  const navigate = useNavigate();

  const {
    updates = [],
    visibleUpdates = [],
    unreadUpdates = [],
    readUpdateIds = [],
    markUpdatesRead,
    markAllVisibleUpdatesRead,
  } = useOutletContext() || {};

  const schoolUpdates = useMemo(() => {
    const source =
  unreadUpdates?.length
    ? unreadUpdates
    : visibleUpdates?.length
      ? visibleUpdates
      : updates;
    const readIds = readUpdateIds.map(String);

    return source.map((item) => {
      const id = String(item.id || item.updateId || item.docId || "");
      const read =
  unreadUpdates?.length
    ? false
    : readIds.includes(id);
      const tone = getUpdateTone(item, read);

      return {
        id,
        type: "school_update",
        title: item.title || item.headline || item.subject || "School update",
        body: item.body || item.message || item.content || "Open this school update.",
        date: item.createdAt || item.updatedAt || item.date,
        read,
        tone,
        raw: item,
      };
    });
  }, [visibleUpdates, updates, readUpdateIds]);

const allNotifications = useMemo(() => {
  return [...schoolUpdates]
    .filter((item) => !item.read)
    .sort((a, b) => {
      const ad =
        a.date?.toMillis?.() ||
        new Date(a.date || 0).getTime() ||
        0;

      const bd =
        b.date?.toMillis?.() ||
        new Date(b.date || 0).getTime() ||
        0;

      return bd - ad;
    });
}, [schoolUpdates]);

  const unreadTotal = allNotifications.filter((item) => !item.read).length;
const [selectedAlert, setSelectedAlert] = useState(null);
const [alertModalOpen, setAlertModalOpen] = useState(false);

  async function markAllRead() {
    const updateIds = schoolUpdates.filter((item) => !item.read).map((item) => item.id);

    if (typeof markAllVisibleUpdatesRead === "function") {
      await markAllVisibleUpdatesRead();
      return;
    }

    if (updateIds.length && typeof markUpdatesRead === "function") {
      await markUpdatesRead(updateIds);
    }
  }

async function openNotification(item) {
  if (typeof markUpdatesRead === "function" && item?.id) {
    await markUpdatesRead([item.id]);
  }

  setSelectedAlert(item);
  setAlertModalOpen(true);
}

  return (
    <div className="pp-parent-main-content pp-home-premium">
      <section className="pp-card pp-home-hero-card">
        <div className="pp-home-hero-glow" />

        <div className="pp-home-hero-top">
          <div className="pp-home-copy-block">
            <p className="pp-home-eyebrow">Notifications</p>
            <h2 className="pp-home-title">School alerts</h2>
            <p className="pp-home-subtitle">
              School updates, attendance messages, reports, and important notices in one place.
            </p>
          </div>

          <button type="button" className="pp-home-status-pill" onClick={markAllRead}>
            <span className="pp-home-status-dot" />
            <span>{unreadTotal ? `${unreadTotal} unread` : "All read"}</span>
          </button>
        </div>

        <div className="pp-home-hero-grid">
          <div className="pp-home-info-tile">
            <span>Unread</span>
            <strong>{unreadTotal}</strong>
            <small>notifications</small>
          </div>

          <div className="pp-home-info-tile">
            <span>School updates</span>
            <strong>{schoolUpdates.length}</strong>
            <small>parent-safe notices</small>
          </div>
        </div>
      </section>

      <section className="pp-card pp-home-update-card">
        <div className="pp-home-update-top">
          <span className="pp-home-update-icon">
            <BellIcon />
          </span>

          <div className="pp-home-update-copy-wrap">
            <p className="pp-home-eyebrow">Inbox</p>
            <h3 className="pp-home-update-title">Latest notifications</h3>
            <p className="pp-home-update-copy">
              {unreadTotal ? "You have unread notifications." : "You’re all caught up."}
            </p>
          </div>
        </div>

        {allNotifications.length ? (
          <div className="pp-home-focus-grid">
            {allNotifications.map((item) => (
              <button
                key={`${item.type}-${item.id}`}
                type="button"
                className={`pp-home-focus-tile ${item.read ? "good" : "alert"}`}
                onClick={() => openNotification(item)}
              >
                <span className="pp-home-focus-icon">
                  <BellIcon />
                </span>

                <span className="pp-home-focus-content">
                  <strong>{item.title}</strong>
                  <small>{item.body}</small>
                </span>

                <span
                  style={{
                    padding: "7px 10px",
                    borderRadius: 999,
                    background: item.tone?.bg || "#fef0c7",
                    color: item.tone?.color || "#b54708",
                    fontSize: 11,
                    fontWeight: 900,
                    textTransform: "uppercase",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item.tone?.label || "New"}
                </span>

                <span className="pp-home-focus-arrow">
                  <ChevronIcon />
                </span>
              </button>
            ))}
          </div>
        ) : (
          <div className="pp-card" style={{ boxShadow: "none", margin: 0 }}>
            No notifications yet.
          </div>
        )}
      </section>

      <section className="pp-card pp-home-quick-card">
        <div className="pp-home-section-head">
          <div>
            <p className="pp-home-eyebrow">Privacy</p>
            <h3 className="pp-home-section-title">Child-specific alerts</h3>
          </div>
        </div>

        <p className="pp-home-update-copy" style={{ marginTop: 0 }}>
          Notifications are specific to each linked child profile.
        </p>

        <div className="pp-home-quick-grid">
          <button
            type="button"
            className="pp-home-action-card soft"
            onClick={() => navigate("/parent/updates")}
          >
            <span className="pp-home-action-icon">
              <ChevronIcon />
            </span>
            <span className="pp-home-action-copy">
              <strong>Open updates</strong>
              <small>View school and class notices</small>
            </span>
          </button>

          <button
            type="button"
            className="pp-home-action-card soft"
            onClick={() => navigate("/parent/home")}
          >
            <span className="pp-home-action-icon">
              <BellIcon />
            </span>
            <span className="pp-home-action-copy">
              <strong>Go home</strong>
              <small>Return to parent dashboard</small>
            </span>
          </button>
        </div>
      </section>
      {alertModalOpen && selectedAlert && (
  <div
    className="pp-modal-backdrop"
    onClick={() => setAlertModalOpen(false)}
  >
    <div
      className="pp-modal-card"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="pp-modal-top">
        <div>
          <p className="pp-home-eyebrow">School alert</p>
          <h3 className="pp-home-section-title">
            {selectedAlert.title}
          </h3>
        </div>

        <button
          type="button"
          className="pp-modal-close"
          onClick={() => setAlertModalOpen(false)}
        >
          ×
        </button>
      </div>

      <div className="pp-modal-content">
        <p>{selectedAlert.body}</p>
      </div>
    </div>
  </div>
)}
    </div>
  );
}